import { Link } from "react-router-dom"
import Button from "../common/Button"

export default function DashboardViewAll({urlPage}) {
    return <div>
        {!urlPage && <Button btnStyle='btn_simple' >View All <i className="ti ti-arrow-up-right"></i></Button>}
        {urlPage && <Link to={urlPage}>View All <i className="ti ti-arrow-up-right"></i></Link>}
    </div>
}